"use strict";

var _objectSpread = require("/var/www/ivy-temp/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_VENUE_TYPE_EMOJI_LENGTH = exports.MAX_VENUE_TYPE_LABEL_LENGTH = exports.DEFAULT_VENUE_TYPE_LABELS = void 0;
exports.buildDefaultVenueTypeLabels = buildDefaultVenueTypeLabels;
exports.parseVenueTypeLabels = parseVenueTypeLabels;
exports.validateVenueTypeLabelsForSave = validateVenueTypeLabelsForSave;
const enums_1 = require("../enums");
exports.DEFAULT_VENUE_TYPE_LABELS = [{
  type: enums_1.VenueType.Bar,
  label: 'Bar',
  emoji: '🍸'
}, {
  type: enums_1.VenueType.Restaurant,
  label: 'Restaurant',
  emoji: '🍽️'
}, {
  type: enums_1.VenueType.Nightclub,
  label: 'Nightclub',
  emoji: '🪩'
}, {
  type: enums_1.VenueType.Cafe,
  label: 'Cafe',
  emoji: '☕'
}, {
  type: enums_1.VenueType.Other,
  label: 'Other',
  emoji: '📍'
}, {
  type: enums_1.VenueType.Gym,
  label: 'Gym',
  emoji: '💪'
}, {
  type: enums_1.VenueType.Bookstore,
  label: 'Bookstore',
  emoji: '📚'
}, {
  type: enums_1.VenueType.Museum,
  label: 'Museum',
  emoji: '🖼️'
}, {
  type: enums_1.VenueType.Park,
  label: 'Park',
  emoji: '🌳'
}, {
  type: enums_1.VenueType.Outside,
  label: 'Outside',
  emoji: '🌤️'
}, {
  type: enums_1.VenueType.Shop,
  label: 'Shop',
  emoji: '🛍️'
}, {
  type: enums_1.VenueType.Party,
  label: 'Party',
  emoji: '🎉'
}, {
  type: enums_1.VenueType.Movies,
  label: 'Movies',
  emoji: '🎬'
}, {
  type: enums_1.VenueType.Concert,
  label: 'Concert',
  emoji: '🎵'
}, {
  type: enums_1.VenueType.Coffee,
  label: 'Coffee',
  emoji: '☕'
}, {
  type: enums_1.VenueType.Attraction,
  label: 'Attraction',
  emoji: '🎡'
}];
exports.MAX_VENUE_TYPE_LABEL_LENGTH = 40;
exports.MAX_VENUE_TYPE_EMOJI_LENGTH = 8;
function buildDefaultVenueTypeLabels() {
  return exports.DEFAULT_VENUE_TYPE_LABELS.map(entry => _objectSpread({}, entry));
}
/** Ensures exactly one entry per [VenueType], in enum order — unknown/duplicate
 * types are dropped, missing ones fall back to the default label/emoji. */
function parseVenueTypeLabels(raw) {
  const defaults = buildDefaultVenueTypeLabels();
  if (!Array.isArray(raw)) {
    return defaults;
  }
  const byType = new Map();
  for (const entry of raw) {
    var _ref, _ref2;
    if (!entry || typeof entry !== 'object') continue;
    const value = entry;
    const type = value.type;
    if (typeof type !== 'string' || !Object.values(enums_1.VenueType).includes(type)) continue;
    if (byType.has(type)) continue;
    const label = typeof value.label === 'string' && value.label.trim() ? value.label.trim() : null;
    const emoji = typeof value.emoji === 'string' && value.emoji.trim() ? value.emoji.trim() : null;
    const fallback = defaults.find(d => d.type === type);
    byType.set(type, {
      type: type,
      label: (_ref = label !== null && label !== void 0 ? label : fallback === null || fallback === void 0 ? void 0 : fallback.label) !== null && _ref !== void 0 ? _ref : type,
      emoji: (_ref2 = emoji !== null && emoji !== void 0 ? emoji : fallback === null || fallback === void 0 ? void 0 : fallback.emoji) !== null && _ref2 !== void 0 ? _ref2 : ''
    });
  }
  return defaults.map(fallback => {
    var _byType$get;
    return (_byType$get = byType.get(fallback.type)) !== null && _byType$get !== void 0 ? _byType$get : fallback;
  });
}
function validateVenueTypeLabelsForSave(value) {
  if (!Array.isArray(value)) {
    return {
      message: 'venueTypeLabels must be an array.'
    };
  }
  if (value.length !== Object.values(enums_1.VenueType).length) {
    return {
      message: "venueTypeLabels must include exactly ".concat(Object.values(enums_1.VenueType).length, " entries.")
    };
  }
  const seen = new Set();
  for (let i = 0; i < value.length; i++) {
    const entry = value[i];
    if (!entry || typeof entry !== 'object') {
      return {
        message: "venueTypeLabels[".concat(i, "] must be an object.")
      };
    }
    const {
      type,
      label,
      emoji
    } = entry;
    if (typeof type !== 'string' || !Object.values(enums_1.VenueType).includes(type)) {
      return {
        message: "venueTypeLabels[".concat(i, "].type must be a valid VenueType.")
      };
    }
    if (seen.has(type)) {
      return {
        message: "Duplicate venueTypeLabels type \"".concat(type, "\".")
      };
    }
    seen.add(type);
    if (typeof label !== 'string' || !label.trim() || label.length > exports.MAX_VENUE_TYPE_LABEL_LENGTH) {
      return {
        message: "venueTypeLabels[".concat(i, "].label must be a non-empty string up to ").concat(exports.MAX_VENUE_TYPE_LABEL_LENGTH, " characters.")
      };
    }
    if (typeof emoji !== 'string' || !emoji.trim() || emoji.length > exports.MAX_VENUE_TYPE_EMOJI_LENGTH) {
      return {
        message: "venueTypeLabels[".concat(i, "].emoji must be a non-empty string up to ").concat(exports.MAX_VENUE_TYPE_EMOJI_LENGTH, " characters.")
      };
    }
  }
  return null;
}
//# sourceMappingURL=venue-type-labels-config.js.map